import { useState, useEffect, useRef } from 'react';
import { IonButton, IonItem, IonLabel, IonRow } from '@ionic/react';
import ValidatedInput from '@/components/ValidatedInput';

const OPTIONS = [5, 10, 15];
const formatCurrency = (amount) => _.toNumber(amount).toFixed(2);

export default function TipSelection({amount, tip, setTip, tipValid}) {
  const inputRef = useRef();
  const [selected, setSelected] = useState();
  const toggle = (val) => (e) => {
    if (selected == val) {
      setSelected(null);
      setTip(null);
    } else {
      setSelected(val);
      if (val === 'other') {
        _.defer(() => inputRef.current?.setFocus());
      } else {
        setTip(formatCurrency(amount * val / 100));
      }
    }
  };
  return <>
    <IonItem lines="none">
      <IonLabel style={{marginRight: 0, marginBottom: 0}}>
        <h2>Tip the attendant</h2>

        <div className="option-touch-buttons">
          {OPTIONS.map((pct) => (
            <IonButton key={pct}
              fill={selected === pct ? "solid" : "outline"}
              color="secondary"
              onClick={toggle(pct)}
            >
              {pct}%
            </IonButton>
          ))}
          <IonButton
            fill={selected === "other" ? "solid" : "outline"}
            color="secondary"
            onClick={toggle("other")}
          >
            Other
          </IonButton>
        </div>
      </IonLabel>
    </IonItem>

    <IonItem lines="none">
      <ValidatedInput
        ref={inputRef}
        label="Tip Amount ($)"
        type="number"
        labelPlacement="start"
        name="tip"
        style={{textAlign: 'right'}}
        value={tip}
        setValue={setTip}
        valid={tipValid}
        readonly={selected > 0}
        disabled={selected == null}
        onIonBlur={Boolean(tip) && (() => setTip(formatCurrency(tip)))}
        min={0}
        step="0.01"/>
    </IonItem>
  </>;
}
